import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ALERT_HISTORY_DEFAULT_CONTEXT } from './alertHistoryDefaultContext';

const AlertHistoryWidgetEdit = ({ context, onChange }) => {
  // Seed defaults on first mount so persisted context always carries the
  // fields the view expects (mirrors AlertsListWidgetEdit).
  useEffect(() => {
    if (context.rowsPerPage == null) {
      onChange({
        ...ALERT_HISTORY_DEFAULT_CONTEXT,
        ...context,
        rowsPerPage: ALERT_HISTORY_DEFAULT_CONTEXT.rowsPerPage,
      });
    }
  }, []);

  return (
    <div className="form-group">
      <small className="form-text text-muted">
        Displays history for all alerts. Use the column picker on the table
        to adjust visible columns.
      </small>
    </div>
  );
};

AlertHistoryWidgetEdit.propTypes = {
  context: PropTypes.shape({
    rowsPerPage: PropTypes.number,
    disabledColumns: PropTypes.arrayOf(PropTypes.string),
  }),
  onChange: PropTypes.func,
};

AlertHistoryWidgetEdit.defaultProps = {
  context: {},
  onChange: () => {},
};

export default AlertHistoryWidgetEdit;
